import { error } from "toastr";
import {
    GET_PING_MONITORS,
    GET_PING_MONITORS_SUCCESS,
    GET_PING_MONITORS_FAIL,
    GET_PING_MONITOR_DETAIL,
    GET_PING_MONITOR_DETAIL_SUCCESS,
    GET_PING_MONITOR_DETAIL_FAIL,
    ADD_PING_MONITORS,
    ADD_PING_MONITORS_SUCCESS,
    ADD_PING_MONITORS_FAIL,
    EDIT_PING_MONITORS,
    EDIT_PING_MONITORS_SUCCESS, 
    EDIT_PING_MONITORS_FAIL,
    MAP_ENDPOINT_TO_SERVICE,
    MAP_ENDPOINT_TO_SERVICE_FAIL,
    MAP_ENDPOINT_TO_SERVICE_SUCCESS,
    GET_ENDPOINT_BY_SERVICE_ID,
    GET_ENDPOINT_BY_SERVICE_ID_FAIL,
    GET_ENDPOINT_BY_SERVICE_ID_SUCCESS,
    GET_TIMESTAMPS,
    GET_TIMESTAMPS_FAIL,
    GET_TIMESTAMPS_SUCCESS,
    DELETE_ENDPOINT,
    DELETE_ENDPOINT_SUCCESS,
    DELETE_ENDPOINT_FAIL,
    TOGGLE_ENDPOINT,
    TOGGLE_ENDPOINT_SUCCESS,
    TOGGLE_ENDPOINT_FAIL,
    GET_TIMESTAMPS_BY_SERVICE_ID,
    GET_TIMESTAMPS_BY_SERVICE_ID_FAIL,
    GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS,
    GET_UPTIME_CHECK_FAILURES,
    GET_UPTIME_CHECK_FAILURES_SUCCESS,
    GET_UPTIME_CHECK_FAILURES_FAIL,
    VALIDATE_REGEX,
    VALIDATE_REGEX_SUCCESS,
    VALIDATE_REGEX_FAIL,
} from "./actionTypes";

export const getPingMonitors = () => ({
    type: GET_PING_MONITORS,
})

export const getPingMonitorsSuccess = pingMonitors => ({
    type: GET_PING_MONITORS_SUCCESS,
    payload: pingMonitors,
})

export const getPingMonitorsFail = error => ({
    type: GET_PING_MONITORS_FAIL,
    payload: error,
})

export const getPingMonitorDetail = (id) => ({
    type: GET_PING_MONITOR_DETAIL,
    payload: id
})

export const getPingMonitorDetailSuccess = (PingMonitorDetails) => ({
    type: GET_PING_MONITOR_DETAIL_SUCCESS,
    payload: PingMonitorDetails
})

export const getPingMonitorDetailFail = error => ({
    type: GET_PING_MONITOR_DETAIL_FAIL,
    payload: error,
})

export const getUptimeCheckFailures = (payload) => ({
    type: GET_UPTIME_CHECK_FAILURES,
    payload: payload
})

export const getUptimeCheckFailuresSuccess = (data) => ({
    type: GET_UPTIME_CHECK_FAILURES_SUCCESS,
    payload: data
})

export const getUptimeCheckFailuresFail = (error) => ({
    type: GET_UPTIME_CHECK_FAILURES_FAIL,
    payload: error
})

export const editPingMonitor = (data) => ({
    type: EDIT_PING_MONITORS,
    payload: data
})

export const editPingMonitorSuccess = pingMonitors => ({
    type: EDIT_PING_MONITORS_SUCCESS,
    payload: pingMonitors,
})

export const editPingMonitorFail = error => ({
    type: EDIT_PING_MONITORS_FAIL,
    payload: error,
})

export const addPingMonitor = (data) => ({
    type: ADD_PING_MONITORS,
    payload: data
})

export const addPingMonitorSuccess = pingMonitors => ({
    type: ADD_PING_MONITORS_SUCCESS,
    payload: pingMonitors,
})

export const addPingMonitorFail = error => ({
    type: ADD_PING_MONITORS_FAIL,
    payload: error,
})

export const mapEndpointToService = (data) => ({
    type: MAP_ENDPOINT_TO_SERVICE,
    payload: data
})

export const mapEndpointToServiceFail = error => ({
    type: MAP_ENDPOINT_TO_SERVICE_FAIL,
    payload: error
})

export const mapEndpointToServiceSuccess = response => ({
    type: MAP_ENDPOINT_TO_SERVICE_SUCCESS,
    payload: response
})

export const getEndpointByServiceId = (data) => ({
    type: GET_ENDPOINT_BY_SERVICE_ID,
    payload: data
})

export const getEndpointByServiceIdFail =  error => ({
    type: GET_ENDPOINT_BY_SERVICE_ID_FAIL,
    payload: error
})

export const getEndpointByServiceIdSuccess = (endpointDetails) => ({
    type: GET_ENDPOINT_BY_SERVICE_ID_SUCCESS,
    payload: endpointDetails
})

export const getTimestamps = (data) => ({
    type: GET_TIMESTAMPS,
    payload: data
})

export const getTimestampsFail = (error) => ({
    type: GET_TIMESTAMPS_FAIL,
    payload: error.response?.data || error.message,
})

export const getTimestampsSuccess = timestamps => ({
    type: GET_TIMESTAMPS_SUCCESS,
    payload: timestamps
})

export const deleteEndpoint = endpointId => ({
    type: DELETE_ENDPOINT,
    payload: endpointId
})

export const deleteEndpointFail = (error) => ({
    type: DELETE_ENDPOINT_FAIL,
    payload: error.response?.data || error.message,
})

export const deleteEndpointSuccess = message => ({
    type: DELETE_ENDPOINT_SUCCESS,
    payload: message,
})

export const toggleEndpoint =  data => ({
    type: TOGGLE_ENDPOINT,
    payload: data
})

export const toggleEndpointSuccess = (message) => ({
    type: TOGGLE_ENDPOINT_SUCCESS,
    payload: message
})

export const toggleEndpointFail = (error) => ({
    type: TOGGLE_ENDPOINT_FAIL,
    payload: error
})

export const getTimestampsByServiceId = data => ({
    type: GET_TIMESTAMPS_BY_SERVICE_ID,
    payload: data
})

export const getTimestampsByServiceIdFail = error => ({
    type: GET_TIMESTAMPS_BY_SERVICE_ID_FAIL,
    payload: error
})

export const getTimestampsByServiceIdSuccess = timestamps => ({
    type: GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS,
    payload: timestamps
})

export const validateRegex = data => ({
    type: VALIDATE_REGEX,
    payload: data
})

export const validateRegexSuccess = data => ({
    type: VALIDATE_REGEX_SUCCESS,
    payload: data
})

export const validateRegexFail = error => ({
    type: VALIDATE_REGEX_FAIL,
    payload: error
})
